export const SETTINGS_WRITE_ONLY_VALUE_MASK = '********'

export const SettingsStatusTone = {
  Fail: 'fail',
  InProgress: 'inProgress',
  Neutral: 'neutral',
  Ok: 'ok',
}
